export const stringOperators = [
    {machineName: 'exact', humanName: 'Exact Match'},
    {machineName: 'iexact', humanName: 'Case Insensitive Match'},
    {machineName: 'contains', humanName: 'Contains'},
    {machineName: 'icontains', humanName: 'Case Insensitive Contains'},
    {machineName: 'startswith', humanName: 'Starts With'},
    {machineName: 'istartswith', humanName: 'Case Insensitive Starts With'},
    {machineName: 'endswith', humanName: 'Ends With'},
    {machineName: 'iendswith', humanName: 'Case Insensitive Ends With'},
];

export const integerOperators = [
    {machineName: 'exact',  humanName: 'Equal'},
    {machineName: 'gt',     humanName: 'Greater Than'},
    {machineName: 'gte',    humanName: 'Greater Than or Equal'},
    {machineName: 'lt',     humanName: 'Less Than'},
    {machineName: 'lte',    humanName: 'Less Than or Equal'},
    {machineName: 'in',     humanName: 'in'},
];

export const datetimeOperators = [
    {machineName: 'exact',  humanName: 'Equal'},
    {machineName: 'gt',     humanName: 'Greater Than'},
    {machineName: 'gte',    humanName: 'Greater Than or Equal'},
    {machineName: 'lt',     humanName: 'Less Than'},
    {machineName: 'lte',    humanName: 'Less Than or Equal'},
    {machineName: 'in',     humanName: 'in'},
    {machineName: 'isnull', humanName: 'Is empty'},
];

// Operators for the protocol status columns (SyncLog / ApiLog `status`).
// `exact` drives the Success/Error dropdown; `lt`/`gt` stay listed because the
// "Errors only" preset seeds `status < 0 OR status > 0` rows into the filter
// panel and the operator select can only render operators it knows about;
// `isnull` surfaces rows whose outcome could not be derived. All four are in
// the backend's FilterOperators.KEYS whitelist — ComplexFilterBackend silently
// drops operators it doesn't allow, so this list must not grow past KEYS.
export const statusChoiceOperators = [
    {machineName: 'exact',  humanName: 'is'},
    {machineName: 'lt',     humanName: 'Less Than'},
    {machineName: 'gt',     humanName: 'Greater Than'},
    {machineName: 'isnull', humanName: 'Is empty'},
];

export const booleanOperators = [
    {machineName: 'exact',  humanName: 'is'}
];

export const choiceOperators = [
    {machineName: 'exact',  humanName: 'is'},
    // Used by pinned quick-filter rows (e.g. the parameter type chips);
    // encodes a list value as `<column>__in`.
    {machineName: 'in',  humanName: 'is any of'}
];

